import { createFileRoute } from "@tanstack/react-router";
import { PlayerDetailPage } from "@pages/player-details/player-details-page";

export const Route = createFileRoute("/_authenticated/app/players/$playerId/")({
  component: PlayerDetailPage,
});
